import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const CurrentStateOutcomeStyles: moduleStyleType = {
    container: {
        display: 'flex',
        alignItems: 'center',
    },
    textContainer: {
        marginLeft: 1,
    },
    pendingIcon: {
        fontSize: 14,
        color: 'warning.main',
    },
    deletedIcon: {
        fontSize: 14,
        color: 'error.main',
    },
    provisioningIcon: {
        fontSize: 14,
        color: 'primary.main',
    },
}
